import React from "react";
import "shepherd.js/dist/css/shepherd.css";
import "flatpickr/dist/flatpickr.css";
import "choices.js/public/assets/styles/choices.min.css";
import "./assets/scss/hope-ui.scss";
import "./assets/scss/pro.scss";
import "./assets/scss/custom.scss";
import "./assets/scss/dark.scss";
import "./assets/scss/rtl.scss";
import "./assets/scss/customizer.scss";
import "./assets/custom/scss/custom.scss";
import { useDispatch } from "react-redux";
import { setSetting } from "./store/setting/actions";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import * as authSelectors from "./store/auth/selectors";
import Backdrop from "./components/common-components/backdrop";

function App({ children }) {
  const queryClient = new QueryClient();
  const dispatch = useDispatch();
  dispatch(setSetting());
  const user = useSelector(authSelectors.user);

  return (
    <QueryClientProvider client={queryClient}>
      <div className="App">{children}</div>
      <Backdrop />
    </QueryClientProvider>
  );
}

export default App;
